{
  "version": 1,
  "asset_id": "8a7841ba-3304-4249-8ebe-52511e8eb8c5",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/8a7841ba-3304-4249-8ebe-52511e8eb8c5/destination-roofing-owner-sales-team-crystal-river-fl-480w.webp",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/8a7841ba-3304-4249-8ebe-52511e8eb8c5/destination-roofing-owner-sales-team-crystal-river-fl-480w.webp",
  "original_filename": "destination-roofing-owner-sales-team-crystal-river-fl-480w.webp",
  "size": 21076,
  "content_type": "image/webp",
  "created_at": "2026-07-21T15:42:45Z"
}
